// Defensive GA4 / gtag event helper for landing wizards.
// No-op if gtag is not configured — never throws.

export function trackLandingEvent(eventName, params = {}) {
  if (typeof window === 'undefined') return;

  try {
    if (typeof window.gtag === 'function') {
      window.gtag('event', eventName, params);
    } else if (process.env.NODE_ENV !== 'production') {
      // eslint-disable-next-line no-console
      console.debug('[landing] gtag not available, skipped:', eventName, params);
    }
  } catch (err) {
    // eslint-disable-next-line no-console
    console.error('[landing] trackLandingEvent error:', err);
  }
}

const UTM_STORAGE_KEY = 'landing_utm_params';
const URL_STORAGE_KEY = 'landing_url';

export function captureUtmParams() {
  if (typeof window === 'undefined') return {};

  try {
    const params = new URLSearchParams(window.location.search);
    const utm = {};
    params.forEach((value, key) => {
      utm[key] = value;
    });

    if (Object.keys(utm).length > 0) {
      sessionStorage.setItem(UTM_STORAGE_KEY, JSON.stringify(utm));
      sessionStorage.setItem(URL_STORAGE_KEY, window.location.href);
    } else if (!sessionStorage.getItem(URL_STORAGE_KEY)) {
      sessionStorage.setItem(URL_STORAGE_KEY, window.location.href);
    }

    return getStoredUtmParams();
  } catch (err) {
    console.error('[landing] captureUtmParams error:', err);
    return {};
  }
}

export function getStoredUtmParams() {
  if (typeof window === 'undefined') return {};
  try {
    return JSON.parse(sessionStorage.getItem(UTM_STORAGE_KEY) || '{}');
  } catch {
    return {};
  }
}

export function getStoredLandingUrl() {
  if (typeof window === 'undefined') return '';
  try {
    return sessionStorage.getItem(URL_STORAGE_KEY) || window.location.href;
  } catch {
    return typeof window !== 'undefined' ? window.location.href : '';
  }
}
